module.exports = __webpack_public_path__ + "img/medical_physical_01.e1c75ae2.jpg";